import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { PROFILE } from "../../data/content";

export const MiniFooter = () => (
  <section data-testid="mini-footer" className="bg-ink text-paper">
    <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-14 md:py-20 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
      <div>
        <p className="overline text-terracotta">Let's talk</p>
        <p className="mt-3 font-serif text-3xl md:text-4xl tracking-tight">Have a project in mind?</p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <a
          href={`mailto:${PROFILE.email}`}
          data-testid="mini-footer-email"
          className="inline-flex items-center gap-2 rounded-full bg-paper text-ink px-6 py-3 text-sm uppercase tracking-[0.14em] hover:bg-terracotta hover:text-paper transition-colors duration-300"
        >
          <Mail size={15} /> Email me
        </a>
        <Link
          to="/"
          data-testid="mini-footer-home"
          className="inline-flex items-center gap-2 rounded-full border border-white/25 text-paper px-6 py-3 text-sm uppercase tracking-[0.14em] hover:border-paper transition-colors duration-300"
        >
          Full contact <ArrowUpRight size={15} />
        </Link>
      </div>
    </div>
  </section>
);
